import React from 'react';
import { Modal, Button } from 'react-bootstrap';

interface ConfirmationModalProps {
  show: boolean;
  onHide: () => void;
  onConfirm: () => void;
  onCancel?: () => void;
  title?: string;
  message?: string;
  children?: React.ReactNode;
  confirmText?: string;
  cancelText?: string;
  variant?: 'primary' | 'danger' | 'warning' | 'success';
  isLoading?: boolean;
  size?: 'sm' | 'lg' | 'xl';
  dialogClassName?: string;
}

const ConfirmationModal: React.FC<ConfirmationModalProps> = ({
  show,
  onHide,
  onConfirm,
  onCancel,
  title = 'Confirmation',
  message,
  children,
  confirmText = 'Yes',
  cancelText = 'Cancel',
  variant = 'primary',
  isLoading = false,
  size,
  dialogClassName,
}) => {
  return (
    <Modal
      show={show}
      onHide={onHide}
      centered
      backdrop="static"
      keyboard={false}
      size={size}
      dialogClassName={dialogClassName}
    >
      <Modal.Header closeButton>
        <Modal.Title>{title}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {message ? <p className="mb-0">{message}</p> : null}
        {children}
      </Modal.Body>
      {(cancelText || confirmText) && (
        <Modal.Footer>
          {cancelText && (
            <Button
              variant="secondary"
              onClick={onCancel ?? onHide}
              disabled={isLoading}
            >
              {cancelText}
            </Button>
          )}
          {confirmText && (
            <Button
              variant={variant}
              onClick={onConfirm}
              disabled={isLoading}
            >
              {isLoading ? (
                <>
                  <span
                    className="spinner-border spinner-border-sm me-2"
                    role="status"
                    aria-hidden="true"
                  />
                  Loading...
                </>
              ) : (
                confirmText
              )}
            </Button>
          )}
        </Modal.Footer>
      )}
    </Modal>
  );
};

export default ConfirmationModal;
